import type { HTMLAttributes, ReactNode } from "react";

import { PageContainer } from "@/components/core/page-container";
import { cn } from "@/lib/utils";

interface SectionWrapperProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  eyebrow?: string;
  heading?: string;
  intro?: string;
}

export function SectionWrapper({
  children,
  className,
  eyebrow,
  heading,
  intro,
  ...props
}: SectionWrapperProps): JSX.Element {
  return (
    <section
      className={cn("py-14 md:py-20", className)}
      {...props}
    >
      <PageContainer>
        {(eyebrow || heading || intro) && (
          <div className="mb-8 max-w-3xl space-y-3 md:mb-10">
            {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
            {heading ? (
              <h2 className="text-balance text-xl leading-[1.1] text-foreground md:text-2xl">
                {heading}
              </h2>
            ) : null}
            {intro ? (
              <p className="max-w-2xl text-sm leading-7 text-spotify-silver md:text-base">
                {intro}
              </p>
            ) : null}
          </div>
        )}
        {children}
      </PageContainer>
    </section>
  );
}
